import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import type { SidebarHeaderProps } from './types';
import { styles } from './styles';

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? '?';
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  userName,
  userRole,
  collapsed,
  onToggle,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={handleKeyDown}
      className={styles.header}>
      <div className={styles.headerAvatar}>{getInitials(userName)}</div>
      <div
        className={clsx(
          styles.headerInfo,
          collapsed ? styles.headerInfoHidden : styles.headerInfoVisible,
        )}>
        <span className={styles.headerName}>{userName}</span>
        <span className={styles.headerRole}>{userRole}</span>
      </div>
      <FontAwesomeIcon
        icon={collapsed ? faChevronRight : faChevronLeft}
        className={clsx(
          styles.headerChevron,
          collapsed ? styles.headerInfoHidden : styles.headerInfoVisible,
        )}
      />
    </div>
  );
};

export default SidebarHeader;
